import{createContext as e,useContext as n}from"react";const t=e(null);function o(){return n(t)||{}}export{t as ListContext,o as useListContext};
